import { ReactComponent as IconClose } from '@/assets/svgs/icon-close.svg'
import Button from '@/components/Button/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from '@/utils/rem'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ReactComponent as IconConfigure } from '@/assets/svgs/icon-configure.svg';

export default function RequestMoreInformationModal({
	visible,
	close,
	submit
}) {
	const [message, setMessage] = React.useState('')
	const { t } = useTranslation()

	return (
		<Modal visible={visible} variant='medium'  close={close}>
			<CardConfigure>
				<CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className={'card-configure__icon'}>
										<IconConfigure />
									</div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Request for more Information
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
				</CardConfigure.Header>
				<CardConfigure.Body>
					<CardConfigure.Body.Col>
						{/* <div style={{ fontSize: rem(14), textAlign: 'center' }}>Are you sure you want to cancel Simulation?</div> */}
						<div className="eclip-receipient__input">
							<span className="eclip-landing-filter--sublabel eclip-landing__create-folder--span">
								Message
							</span>
							<div className="eclip-create__input-description">
								{t('eclipRequestMoreDescription')}
							</div>
							<textarea
								type="text"
								maxLength={400}
								onChange={(e) => {
								setMessage(e.target.value)
								}}
								rows="6"
								value={message}
								placeholder="Type your message"
							/>
						</div>
					</CardConfigure.Body.Col>
				</CardConfigure.Body>
				<CardConfigure.Footer>
					<CardConfigure.Footer.Right>
						<Button ghost text="Cancel" submit={close} />
						<span style={{ width: rem(10), display: 'inline-block' }}></span>
						<Button
							text="Send"
							disabled={!message?.trim()?.length}
							submit={() => {
								submit(message)
							}}
						/>
					</CardConfigure.Footer.Right>
				</CardConfigure.Footer>
			</CardConfigure>
		</Modal>
	)
}
